// extracted by mini-css-extract-plugin
export var divider = "_q9-0";
export var systemMessage = "_q9-1";
export var systemMessageWrapper = "_q9-2";